module.exports = __webpack_public_path__ + "img/70.5f2760f9.png";